import { useEffect, useRef, useState } from 'react'
import { messageType } from '../utils'
import BotResponse from './botResponse'
import UpChevronIcon from '../assets/upChevronIcon'
import DownChevronIcon from '../assets/downChevronIcon'

export default function Main({ sender_id, chatlines, send, goBack, botTyping, config, isExpanded, mainSizing, currentPlugin, isSending, scrollBarButtons, autoScrollDisabled, title}) {
    const {
        mini_bot_avatar_url,
        user_avatar_url,
        user_bg_color,
        user_text_color,
        bot_bg_color,
        bot_text_color,
        chat_bg_color,
    } = config
    const dots = useRef()
    const mainRef = useRef()
    const [sourceInfo, setSourceInfo] = useState('')

    useEffect(() => {
        if (dots.current && !autoScrollDisabled) {
            dots.current.scrollIntoView()
        }
    }, [config, chatlines])

    useEffect(() => {
        setSourceInfo('')
        setTimeout(() => {
            showScrollButtons()
        }, 500) // timeout required to allow for animations to complete before checking if scroll required.
    }, [isExpanded])

    const showScrollButtons = () => {
        if (mainRef.current) {
            if(scrollBarButtons && mainRef.current.scrollHeight-10 > mainRef.current.offsetHeight)  {
                mainRef.current.classList += " scrollbarButtons"
            } else {
                mainRef.current.classList = "main flexC"
            }
         }
    }

    const botResponseWrapper = contentJSX => (
        <div className='flexR imgMsg'>
            <img src={mini_bot_avatar_url} alt='Chatbot Avatar' />
            {contentJSX}
        </div>
    )

    const scrollUp = () => {
        if (mainRef.current) {
            mainRef.current.scrollTop -= 100;
        }
    }
    const scrollDown = () => {
        if (mainRef.current) {
            mainRef.current.scrollTop += 100;
        }
    }

    return (
        <div ref={mainRef} className={`main flexC`} id='sbwidgetmain' onLoad={showScrollButtons} style={{ width: isExpanded ? `calc(${mainSizing.width} - 10px)`: mainSizing.width, height: `calc(${mainSizing.height} - 10px)` }}>
            <span className='scrollButton up' onClick={scrollUp} style={{backgroundColor: chat_bg_color, opacity: 0.9}}><UpChevronIcon stroke='#00000050'/></span>
            <span className='scrollButton down' onClick={scrollDown} style={{backgroundColor: chat_bg_color, opacity: 0.9}}><DownChevronIcon stroke='#00000050'/></span>
            {chatlines.map((l, index) => {
                const isBot = l.type !== messageType.user
                return (
                    <div key={index} className={'lineWrapper flexC ' + (isBot ? 'bot' : 'user')}>
                        {isBot ? (
                            botResponseWrapper(<BotResponse sender_id={sender_id} message={l} config={config} send={send} isExpanded={isExpanded} mainSizing={mainSizing} currentPlugin={currentPlugin} setSourceInfo={setSourceInfo} sourceInfo={sourceInfo} isLast={chatlines.length === index + 1}/>)
                        ) : (
                            <div className='flexR imgMsg'>
                                <div
                                    className={'line user'}
                                    style={{
                                        backgroundColor: user_bg_color,
                                        color: user_text_color,
                                        maxWidth: mainSizing.width,
                                    }}
                                >
                                    {l.message}
                                </div>
                                <img src={user_avatar_url} className='userAviImg' alt='User Avatar'/>
                            </div>
                        )}
                    </div>
                )
            })}
            {botTyping && ( // bit of repetition here...
                <div className='lineWrapper flexC bot'>
                    {botResponseWrapper(
                        <div
                            className='line bot'
                            style={{
                                backgroundColor: bot_bg_color,
                                color: bot_text_color,
                            }}
                        >
                            <div className='bot dots flexR' style={{ backgroundColor: bot_bg_color, color: bot_text_color, margin: 0 }}>
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    )}
                </div>
            )}
            <div className='anchor' ref={dots}></div>
        </div>
    )
}
